import { render, staticRenderFns } from "./UploadFile.template.vue?vue&type=template&id=ed260f4a&scoped=true&"
var script = {}
import style0 from "./UploadFile.template.vue?vue&type=style&index=0&id=ed260f4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed260f4a",
  null
  
)

export default component.exports